import Experience from '../Experience.js'
import Environment from './Environment.js'
import LeePerrySmith from './LeePerrySmith.js'
import Plane from './Plane.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        // Wait for resources
        this.resources.on('ready', () =>
        {
            // Setup
            this.leePerrySmith = new LeePerrySmith()
            // this.floor = new Plane()
            this.environment = new Environment()
        })
    }

    update()
    {
        if(this.leePerrySmith)
            this.leePerrySmith.update()
    }
}